import React, { useContext } from 'react';
import type { DataBlocks } from '../types';

const TruthContext = React.createContext<{
  revealed: boolean;
  setRevealed: (revealed: boolean) => void;
  dataBlocks: Partial<DataBlocks>;
}>({
  revealed: false,
  setRevealed: () => {},
  dataBlocks: {},
});
export const TruthProvider = TruthContext.Provider;
export const useTruth = () => {
  return useContext(TruthContext);
};
